var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273943",
    fillRule: "evenodd",
    d: "M3 5.25a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5H3Zm5 0a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5H8Zm0 6a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5H8ZM7.25 18a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75Zm-5-6a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75ZM3 17.25a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5H3Z",
    clipRule: "evenodd"
  })));
};
export default SvgList;